import i18n from 'i18next';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../../../services/Api';
import { addManagerModalActionTypes } from './Constants';
import * as groupDetailsActions from './Actions';
import * as notificationActions from '../../../../components/notification/Actions';
import * as errorHandlerActions from '../../../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS,
			handleGetInstituteTeachersRequest,
		),
		yield takeLatest(
			addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS,
			handleAddInstituteTeachers,
		),
	]);
}

export function* handleGetInstituteTeachersRequest({ payload }) {
	try {
		const { groupId, queries = {} } = payload || {};

		const { data } = yield call(
			processRequest,
			`groups/${groupId}/institute_teachers`,
			'GET',
			queries,
		);

		yield put(groupDetailsActions.getInstituteTeachersSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(groupDetailsActions.getInstituteTeachersError());
	}
}

export function* handleAddInstituteTeachers({ payload }) {
	try {
		const { groupId, managers, callback } = payload || {};

		yield call(processRequest, `groups/${groupId}/add_managers`, 'POST', {
			user_ids: managers,
		});

		if (callback) callback();

		yield put(groupDetailsActions.addInstituteTeachersSuccess());
		yield put(
			notificationActions.createNotification(
				i18n.t('modals.add_managers_modal.success_notification'),
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(groupDetailsActions.addInstituteTeachersError());
	}
}
